export function safeDateTimeFormat(
  locales?: Intl.LocalesArgument,
  opts?: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormat {
  locales = locales ?? navigator.languages
  try {
    return new Intl.DateTimeFormat(locales, opts)
  } catch {
    console.warn('Failed to create Intl.DateTimeFormat with languages', locales)
    return new Intl.DateTimeFormat(undefined, opts)
  }
}

export function safeNumberFormat(locales?: Intl.LocalesArgument, opts?: Intl.NumberFormatOptions): Intl.NumberFormat {
  locales = locales ?? navigator.languages
  try {
    return new Intl.NumberFormat(locales, opts)
  } catch {
    console.warn('Failed to create Intl.NumberFormat with languages', locales)
    return new Intl.NumberFormat(undefined, opts)
  }
}

export function safeRelativeTimeFormat(
  locales?: Intl.LocalesArgument,
  opts?: Intl.RelativeTimeFormatOptions,
): Intl.RelativeTimeFormat {
  locales = locales ?? navigator.languages
  try {
    return new Intl.RelativeTimeFormat(locales, opts)
  } catch {
    console.warn('Failed to create Intl.RelativeTimeFormat with languages', locales)
    return new Intl.RelativeTimeFormat(undefined, opts)
  }
}
